import { type GooseEvent, type EventCategory } from './eventNames.types';

export const SEARCH_CONTROLS_EVENTS_BY_CATEGORY = {
  INTERACTION: {
    DESTINATION_SELECTED: {
      NAME: 'Destination_Selected',
      OWNER: 'Goose',
      CONTEXT: 'When a traveller selects a destination using the DestinationSelector screen.',
    },
    SEARCH_CONTROL_HIDDEN: {
      NAME: 'Search_Control_Hidden',
      OWNER: 'Goose',
      CONTEXT:
        'When the traveller scrolls page or clicks the dark area underneath to hide search control.',
    },
  },
  BEHAVIOURAL: {
    USER_CLICKS_BAG_FILTER: {
      NAME: 'user_clicks_bag_filter',
      OWNER: 'Goose',
    },
  },
  MINIEVENT_MISC: {},
  SMART_METRICS: {
    FILTER_INTERACTION_TRIGGERED: {
      NAME: 'filter_interaction_triggered',
      OWNER: 'Goose',
    },
  },
} as const satisfies Record<EventCategory, Record<string, GooseEvent>>;
